import React, { Component, Fragment } from "react";
import * as Sentry from "@sentry/react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  restart = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace("/");
  };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
    // logging error into sentry
    Sentry.captureException(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Fragment>
          <div className="not-found d-flex justify-content-center align-items-center">
            <div className="not-found__content d-flex justify-content-center align-items-center flex-column px-3">
              <img src="/images/logo.png" alt="broken-robot" />
              <h4 className="not-found__info w-100 text-center py-4 m-0">
                Something went wrong, Kindly report the problem
              </h4>
              <div className="d-flex justify-content-center align-items-between flex-row flex-wrap g-3">
                <button className="button-common button-fill">
                  <a
                    className="not-found__contact-us-a"
                    onClick={this.restart}
                    href={`${process.env.REACT_APP_MARKETING_SITE_BASE_URL}/contact-us/`}
                  >
                    Contact Us
                  </a>
                </button>

                <button
                  className="not-found__back-to-login button-common button-outline"
                  onClick={this.restart}
                >
                  Go Back to Login
                </button>
              </div>
            </div>
          </div>
        </Fragment>
      );
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
